var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCatalog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 7.11719H8.75033",
    stroke: "#50C878",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 9.45312H7.22199",
    stroke: "#50C878",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39366 1.16406H5.83366C5.25033 1.16406 4.66699 1.16406 4.66699 2.33073C4.66699 3.4974 5.25033 3.4974 5.83366 3.4974H8.16699C9.33366 3.4974 9.33366 2.91406 9.33366 2.33073C9.33366 1.16406 8.75033 1.16406 8.16699 1.16406",
    stroke: "#50C878",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 5.83208C1.75 3.17208 2.72417 2.44875 4.66667 2.34375",
    stroke: "#50C878",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 2.34375C11.2758 2.44875 12.25 3.16625 12.25 5.83208V9.33208C12.25 11.6654 11.6667 12.8321 8.75 12.8321H5.25C2.33333 12.8321 1.75 11.6654 1.75 9.33208V8.11292",
    stroke: "#50C878",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCatalog);
export default __webpack_public_path__ + "static/media/ActiveCatalog.fb1928297b3d0aece00445cc9bf1cc91.svg";
export { ForwardRef as ReactComponent };